import { Accept } from "react-dropzone";
import { ColumnDataTypeEnum } from "./FilterModel";

// enums
export enum InputTypesEnum {
  TEXT = "text",
  DROPDOWN = "dropdown",
  MULTIDROPDOWN = "multi-dropdown",
  FILE = "file",
  SWITCH = "switch",
  BLANK = "blank",
}

export enum TableTypeEnum {
  MASTER = "master",
  DETAIL = "detail",
}

export enum ActionTypes {
  SUM = "sum",
  MIN = "min",
  MAX = "max",
  AVG = "avg",
  COUNT = "count",
  TEXT = "text",
}

// models
export interface IDropdownOptionsModel {
  value: any;
  label: any;
  data?: any;
}

export interface IInputProps {
  value: any;
  options?: any;
  onChange?: Function;
  onBlur?: Function;
  className?: string;
  required?: boolean;
  disabled?: boolean;

  name?: string;
  label?: string;
  onClick?: Function;

  accept?: Accept;
  maxFiles?: number;
  noClick?: boolean;
  noDrag?: boolean;
  maxSize?: number;
  showPreview?: boolean;
  handleChange?: Function;
  min?: number;
  max?: number;
  // canMinMaxValueSame?: boolean;
  isMulti?: boolean;
  ruler?: boolean;
  step?: number;
  initialStartDate?: Date;
  initialEndDate?: Date;
  isDatePicker?: boolean;
  isSingleRange?: boolean;
}

export type AlphaNumbericType = string | number;

export type AlphaNumbericArrayType = string | number | string[] | number[];

export type FilterValueModel = {
  value: AlphaNumbericArrayType;
  type: ColumnDataTypeEnum | string;
};

export interface ObjectModel<T> {
  [x: string]: T;
}

export interface IEnableNestedActionFieldsModel {
  optionId: string;
  optionName: string;
  optionUrl: string;
}

export interface ITableConfigModel {
  pagination: boolean;
  pageCount: number;
  filters: boolean;
  sortable: boolean;
  resizable: boolean;
  draggable: boolean;
  reorder: boolean;

  pin: boolean;
  pinnedColumns: string[];

  enableSummaryRows?: boolean;

  enableExport: boolean;
  enableNestedTable: boolean;
  enableNestedWidget?: any;
  enableNestedMandatoryColumns?: any;

  enableActionDropdown: boolean;
  enableActionFields?: IEnableNestedActionFieldsModel[];
}

export interface IDataSetColumnsModel {
  aliasName: string;
  columnDatatype: string;
  columnName: string;
  actions?: string;
  subType?: string;
  formatRegex?: string;
  formatSwitch?: string;
  hideHeader?: boolean;
  disableFunctions?: boolean;
  name?: string;
  width?: number | string;
  customSortFunction?: Function;
}

export interface IPageDataModel {
  page: number;
  image: any;
  image_size?: {
    [k:string]:number
  };
}

export interface IHighlightCoordinatesModel {
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface IHighlightModel {
  id: string;
  coordinates: IHighlightCoordinatesModel;
}

export interface IHighlightDataModel {
  page: number;
  data: IHighlightModel[];
}

export interface ISearchParamsModel {
  fieldName: string;
  value: string;
}
export interface IDropdownList{
  id:number;
  value: string;
}